var IDs = {};
export default {
    IDs: IDs,
    getData: function (item) { return item; },
    getLegacySeoBlob: function () {
        return { tags: [] };
    },
    getBiData: function getLegacySeoBlob() {
        return { id: null, name: null };
    },
    getKeys: function () { return []; },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
};
